import { sellerCard as baseCard } from '../../../listing/cards';
import { applyOverrides } from '../../../shared';

export const buyerCard = applyOverrides(baseCard, {
  id: 'buySideContacts.buyerX',
  innerTitle: 'Tenant x',
  outerTitle: 'Tenants',
  addableTitle: 'Tenant x',
  addText: 'Tenant',
});
